<template>
  <div class="home">    

    <b-navbar type="dark" variant="dark" fixed="top" toggleable="sm">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand to="/home" active> 🏢 </b-navbar-brand>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item @click="$router.push('/maps')"><b-icon-map></b-icon-map> Map </b-nav-item>
          <b-nav-item @click="$router.push('/building')"><b-icon-building></b-icon-building> Building </b-nav-item>
          <b-nav-item @click="$router.push('/data-warehouse')"><b-icon-file-earmark></b-icon-file-earmark> Data Warehouse </b-nav-item>
          <b-nav-item @click="$router.push('/queries')"><b-icon-newspaper></b-icon-newspaper> Custom Queries </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item @click="logout()"><b-icon-box-arrow-left></b-icon-box-arrow-left> Logout {{username}}
            <b-avatar class="mr-3" size="1.3em"><v-gravatar :size="100" default-img="retro" :email="username" /></b-avatar>
          </b-nav-item>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>

    <main role="main" class="ml-sm-auto px-4">
      <h3>Wifi Density</h3>

      <b-alert variant="warning" show><b-icon-exclamation-triangle></b-icon-exclamation-triangle> This is for developers so most likely you won't find anything useful here 😷 !</b-alert>

      <dl>
        <dt>Build</dt>
        <dd>{{VERSION}}</dd>
        <dt>BASE_URL</dt>
        <dd><a :href="BASE_URL" target="_blank">{{BASE_URL}}</a></dd>
        <dt>API_URL</dt>
        <dd><a :href="API_URL" target="_blank">{{API_URL}}</a></dd>
      </dl>

      <b-checkbox v-model="devexp" @change="setDevExp()" style="display: inline" switch><b>.dev.exp</b></b-checkbox>

      <div class="mt-4" >
      🧪 <b-link @click="$router.push('/experimental')">Experimental stuff</b-link>!
      </div>
    </main>
  </div>
</template>

<script>

export default {
  name: 'home',
  components: { },
  data: function () {
    return {
      VERSION: process.env.VUE_APP_VERSION,
      BASE_URL: process.env.BASE_URL,
      API_URL: process.env.VUE_APP_API_URL,
      devexp: false
    }
  },
  methods: {
    logout() {
      this.$router.push("/logout");
    },
    setDevExp() {
      this.$store.commit("devexp", !this.debug);
    },
  },
  computed: {
    username() { return this.$store.state.user.username }
  },
  mounted() {
    console.log(process.env)
    if (!this.$store.state.user) {
      this.$router.push("/about");
    }
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
main {
  margin-bottom: 4.5rem;
  margin-top: 68px;
  text-align: left;
}

h1, h2, h3 {
  color: #990000;
}

.navbar.navbar-dark.bg-dark{
  background-color: #990000!important;
}

.app-icon {
  width: 32px;
  background-color: white;
  padding: 2px;
}
</style>
